<div class="sidebar-wrapper">
    <p-sidebar transitionOptions="150ms cubic-bezier(0.1, 0.7, 1.0, 0.1)" [(visible)]="is_notification_visible"
        [modal]="true" position="right" [dismissible]="false" [style]="{'overflow': 'visible'}">
        <button *ngIf="is_notification_visible" class="close-button" (click)="closePanel()"><img class="close-btn" src="assets/images/toast/close-icon.svg" alt="Close"></button>
        <div class="header">
            <h4>{{"lang.notification.notifications" | translate}}({{notification_length}})</h4>
            <span (click)="readAllNotification()">{{"lang.notification.Mark_all_as_read" | translate}}</span>
        </div>
        <hr>
        <p-scrollPanel class="notification-panel" [style]="{ width: '100%', height: '95%' }">
            <div class="content" [ngClass]="{TabletPortrait: (responsiveService.deviceTablet() && responsiveService.orientationPortrait()), smallSize: responsiveService.screenSize === 'Small',
                WebPortrait:(responsiveService.deviceDesktop() && responsiveService.orientationPortrait()),mediumSize: responsiveService.screenSize === 'Medium',largeSize: responsiveService.screenSize === 'Large'}">
                <div class="day_data" *ngFor="let data of notification_data">
                    <span>{{utilService.describeDate(data?.day)}}</span>
                    <div class="notification" *ngFor="let notification of data.notification_data"
                        [ngClass]="{'today': notification?.is_notify}" (click)="redirectToRoute(notification)">
                        <img class="user_image" src="{{notification?.img_url}}">
                        <div class="data">
                            <span class="name">{{notification?.name}}</span>
                            <span class="desc">{{notification?.desc}}</span>
                        </div>
                        <span class="time">{{utilService.timeDifference(notification?.time)}}</span>
                    </div>
                    <hr>
                </div>
            </div>
        </p-scrollPanel>
    </p-sidebar>
</div>

